import { Component, Input, OnChanges, SimpleChanges, ViewChild, AfterViewInit, AfterViewChecked } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { HistoryTableColumn } from '@app/shared/models/history.model';

@Component({
  selector: 'flow-history-table',
  templateUrl: './history-table.component.html',
  styleUrls: ['./history-table.component.scss'],
})
export class HistoryTableComponent implements OnChanges, AfterViewInit, AfterViewChecked {
  @Input() title?: string;
  @Input() columns: HistoryTableColumn[] = [];
  @Input() data: any[] = [];
  @Input() pageSize: number = 5;
  @Input() pageSizeOptions: number[] = [5, 10, 25, 100];
  @Input() enableSorting: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource = new MatTableDataSource<any>([]);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.dataSource.data = this.data || [];
    }
  }

  ngAfterViewInit(): void {
    this.paginatorEvent();
    this.sortEvent();
  }

  ngAfterViewChecked(): void {
    if (!this.dataSource.paginator && this.paginator && this.data.length > this.pageSize) {
      this.paginatorEvent();
    }
    if (!this.dataSource.sort && this.sort && this.enableSorting) {
      this.sortEvent();
    }
  }

  private paginatorEvent(): void {
    if (this.paginator && !this.dataSource.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }

  private sortEvent(): void {
    if (this.sort && !this.dataSource.sort && this.enableSorting) {
      this.dataSource.sort = this.sort;
    }
  }

  getColumnKeys(): string[] {
    return this.columns.map(col => col.key);
  }
}
